
import Vue from 'vue';
import { newClient } from './axios-client-new';
import { newClient as newClientOld } from './axios-client-old';
import { get } from '@/util';
import { Dialog } from 'vant';
import { getAppName, isBondo } from "../util";
import {
  mapFields,
  mapFieldsReverse, microPayResultMap,
  PAT_RESULT_MAP,
  PAY_CHANNELS_PARAM_MAP,
  PAY_INTERFACE_MAP, PAY_MICRO_PARAM_MAP
} from "../util/FieldMapUtil";
import {getUserInfoCache} from "../tools/common";
let appName = getAppName();
const isInBondo = isBondo()

// 下单接口超时配置（30s）。
// 接口超时后由 axios-client 的拦截器把 error.message 改成本地化的"网络繁忙"，
// loading / Toast 由调用方自行管理。
export const PAY_REQUEST_TIMEOUT = 30000;

// 获取当前地区
export const getCountryListAjax = function (language) {
  const url = isInBondo ? '/bondo/base/country/list' : '/web/h5/getCountryList?language=' + language
  return newClientOld().post(url)
}


// 获取充值列表
export const getPayChannelsAjax = function (params) {
  const userInfo = getUserInfoCache()
  let url = '/web/h5/getPayChannels'
  if (isInBondo) {
    url = userInfo ? '/bondo/home/auth/user/pay/getTypes' : '/bondo/home/user/pay/getTypes'
    params = mapFieldsReverse(params, PAY_CHANNELS_PARAM_MAP)
  }
  return newClientOld().get(url, { params: params })
}
// 创建订单
export const createOrderAjax = async function (params, payPlatformId) {
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  let api = '';
  if(payPlatformId === 10076){
    api = process.env.paypal_created_api_10076;
  }
  let payResult
  if(isInBondo) {
    const model = mapFieldsReverse(newJson, PAY_INTERFACE_MAP)
    payResult = await newClientOld().post('/bondo/home/auth/user/pay/send?param='+encodeURIComponent(JSON.stringify(model)), undefined, { timeout: PAY_REQUEST_TIMEOUT });
    console.log('-----payResult-----', payResult)
    if(payResult && payResult.data && payResult.data.data) {
      payResult.data.result = mapFields(payResult.data.data, PAT_RESULT_MAP)
      delete payResult.data.data
    }
  } else {
    payResult = await newClientOld().post(api+'/web/h5/pay/createOrder?param='+encodeURIComponent(JSON.stringify(newJson)), undefined, { timeout: PAY_REQUEST_TIMEOUT });
  }
  await  handleFirstPayAfter(payResult);
  return payResult;
}

// pagSmile支付方式
export const pagSmileCreateOrderAjax = async function (params) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/pagSmile/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)), undefined, { timeout: PAY_REQUEST_TIMEOUT });
  await handleFirstPayAfter(payResult);
  return payResult;
}

// payssion支付方式
export const payssionCreateOrderAjax = async function (params) {
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  let payResult
  if(isInBondo) {
    const model = mapFieldsReverse(newJson, PAY_MICRO_PARAM_MAP)
    payResult = await newClient().post('/bondo/auth/trade/payssion/recharge/sendPay', model, { timeout: PAY_REQUEST_TIMEOUT });
    microPayResultMap(payResult)
  } else {
    payResult = await newClient().post('/api/h5/token/trade/payssion/payIn/sendPay',newJson, { timeout: PAY_REQUEST_TIMEOUT });
  }
  await  handleFirstPayAfter(payResult);
  return payResult;
}

// dlocal 支付方式
export const dlocalCreateOrderAjax = async function (params) {
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  let payResult
  if(isInBondo) {
    const model = mapFieldsReverse(newJson, PAY_MICRO_PARAM_MAP)
    payResult = await newClient().post('/bondo/auth/trade/dlocal/recharge/sendPay', model, { timeout: PAY_REQUEST_TIMEOUT });
    microPayResultMap(payResult)
  } else {
    payResult = await newClient().post('/api/h5/token/trade/dlocal/payIn/sendPay?param='+encodeURIComponent(JSON.stringify(newJson)), undefined, { timeout: PAY_REQUEST_TIMEOUT });
  }
  await  handleFirstPayAfter(payResult);
  return payResult;
}


// 订单处理后首充
async function handleFirstPayAfter(payResult) {

  // 风险值过高
  let message;
  if(get(payResult, 'data.data.payUrl')  == -1 || get(payResult, 'result.payUrl') == -1) {
    message = window.rootApp.$t('m.pay_fail_system_risk')  + window.rootApp.$t('m.support_contant_whatsapp', { msg: appName });
  }

  if(get(payResult, 'data.data.payUrl')  == -2 || get(payResult, 'result.payUrl') == -2) {
    message = window.rootApp.$t('m.paystyle_unavailabel_change_other') + window.rootApp.$t('m.support_contant_whatsapp', { msg: appName });
  }

  if (message) {
    Dialog.alert({
      message: message,
      confirmButtonText: 'OK'
    });
    return Promise.reject('error payIndex')
  }
}


// dukPay 支付方式
export const dukPayCreateOrderAjax = async function (params) {
  const newJson = {
    ...params,
    "source":Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  let payResult
  if(isInBondo) {
    const model = mapFieldsReverse(newJson, PAY_MICRO_PARAM_MAP)
    payResult = await newClient().post('/bondo/auth/trade/dukPay/recharge/sendPay', model, { timeout: PAY_REQUEST_TIMEOUT });
    microPayResultMap(payResult)
  } else {
    payResult = await newClient().post('/api/h5/token/trade/dukPay/payIn/sendPay?param='+encodeURIComponent(JSON.stringify(newJson)), undefined, { timeout: PAY_REQUEST_TIMEOUT });
  }
  await  handleFirstPayAfter(payResult);
  return payResult;
}

// CodaPay 支付方式
export const codaPayCreateOrderAjax = async function (params) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  let payResult
  if(isInBondo) {
    const model = mapFieldsReverse(newJson, PAY_MICRO_PARAM_MAP)
    payResult = await newClient().post('/bondo/auth/trade/coda/recharge/sendPay', model, { timeout: PAY_REQUEST_TIMEOUT });
    microPayResultMap(payResult)
  } else {
    payResult = await newClient().post('/api/h5/token/trade/coda/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)), undefined, { timeout: PAY_REQUEST_TIMEOUT });
  }
  await handleFirstPayAfter(payResult);
  return payResult;
}

// HaiPay 支付方式
export const haiPayCreateOrderAjax = async function (params) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source
  }
  let payResult
  if(isInBondo) {
    const model = mapFieldsReverse(newJson, PAY_MICRO_PARAM_MAP)
    payResult = await newClient().post('/bondo/auth/trade/haiPay/recharge/sendPay', model, { timeout: PAY_REQUEST_TIMEOUT });
    microPayResultMap(payResult)
  } else {
    payResult = await newClient().post('/api/h5/token/trade/haipay/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)), undefined, { timeout: PAY_REQUEST_TIMEOUT });
  }
  await handleFirstPayAfter(payResult);
  return payResult;
}

/**
 * peymentWall-paypal充值方式
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const paymentWallPaypalCreateOrder = async function (params) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/paymentWallPayPal/payIn/sendPay', newJson, { timeout: PAY_REQUEST_TIMEOUT });
  await handleFirstPayAfter(payResult);
  return payResult;
}



// WEBPACK FOOTER //
// ./src/api/pay.js